import { useEffect, useState } from "react";
import { ArrowLeft, Loader2, MailCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

export const VerificationAppareil = ({ defi, onSucces, onRetour }) => {
  const { ouvrirSession } = useAuth();
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [msg, setMsg] = useState(`Code envoyé à ${defi.email}, valable ${defi.minutes} minutes.`);
  const [loading, setLoading] = useState(false);
  const [bloque, setBloque] = useState(false);
  const [attente, setAttente] = useState(defi.delai_renvoi);

  useEffect(() => {
    if (attente <= 0) { return undefined; }
    const t = setTimeout(() => setAttente(attente - 1), 1000);
    return () => clearTimeout(t);
  }, [attente]);

  const verifier = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { const { data } = await api.post("/auth/verifier-appareil", { defi: defi.defi, code: code.trim() }); ouvrirSession(data); onSucces(); }
    catch (err) { setError(errMsg(err)); if (err.response?.status === 429) { setBloque(true); } setCode(""); }
    finally { setLoading(false); }
  };
  const renvoyer = async () => {
    setError("");
    try { const { data } = await api.post("/auth/renvoyer-code", { defi: defi.defi }); setMsg(data.message); setAttente(defi.delai_renvoi); }
    catch (err) { setError(errMsg(err)); }
  };

  return (
    <form onSubmit={verifier} className="px-7 pt-8 pb-6" data-testid="verif-form">
      <MailCheck className="h-7 w-7 text-emerald-700" />
      <h2 className="mt-4 text-2xl font-bold tracking-tight">Nouvel appareil</h2>
      <p className="mt-1 text-sm text-slate-500" data-testid="verif-message">{msg}</p>
      <div className="mt-6 space-y-4">
        <div className="space-y-1.5">
          <Label htmlFor="verif-code">Code de vérification</Label>
          <Input id="verif-code" required autoFocus inputMode="numeric" autoComplete="one-time-code" maxLength={6} pattern="\d{6}" disabled={bloque}
            value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} className="font-mono tracking-[0.4em] text-center text-lg" data-testid="verif-code-input" />
          <p className="text-[11px] text-slate-500">Une fois validé, cet appareil sera mémorisé jusqu'à ce que vous le retiriez dans Paramètres.</p>
        </div>
        {error && <p className="text-sm text-red-600" data-testid="verif-error">{error}</p>}
        <Button type="submit" disabled={loading || bloque || code.length !== 6} className="w-full bg-emerald-700 hover:bg-emerald-800" data-testid="verif-submit-button">
          {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Valider
        </Button>
        {!bloque && (
          <button type="button" onClick={renvoyer} disabled={attente > 0} className="w-full text-xs text-slate-500 hover:text-emerald-700 disabled:opacity-60 disabled:hover:text-slate-500" data-testid="verif-renvoyer">
            {attente > 0 ? `Renvoyer le code (${attente} s)` : "Renvoyer le code"}
          </button>
        )}
      </div>
      <button type="button" onClick={() => onRetour(bloque ? error : "")} className="mt-6 inline-flex items-center gap-1 text-xs text-slate-500 hover:text-emerald-700" data-testid="verif-retour">
        <ArrowLeft className="h-3.5 w-3.5" />Retour à la connexion
      </button>
    </form>
  );
};
